<template lang="html">

  <footer class="footer row-between">

    <img src="/static/img/logo.svg" width="150" alt="Logo footer Dotia">

    <nav>
      <a target="_blank" href="https://portal-demoempleo.dotia.online/politica-de-cookies/">Política de Cookies</a>
      <a target="_blank" href="https://portal-demoempleo.dotia.online/aviso-legal/">Aviso legal</a>
      <a target="_blank" href="https://portal-demoempleo.dotia.online/proteccion-de-datos/">Política de privacidad</a>
      <div class="box-sepe">
        <img src="/static/img/logo-sepe.jpg" alt="Logo Sepe">
        <strong>Agencia de Colocación Nº 0800000285</strong>
      </div>
    </nav>

  </footer>

</template>

<script lang="js">
  export default {
    name: 'app-footer',
  }
</script>

<style scoped>
  .footer {}
</style>


// WEBPACK FOOTER //
// src/components/parts/footer.vue